import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from '../../../../environments/environment';
import { BaseResponseModel } from '../../common/models/base-response.model';
import { Observable } from 'rxjs';
import { SingleResponseModel } from '../../common/models/single-response.model';
import { FileModel } from '../../common/models/file.model';
import { PaginableResponseModel } from '../../common/models/paginable-response.model';
import { AdminVerifactuAuthorizationModel } from '../models/admin-verifactu-authorization.model';

@Injectable()
export class AdminVerifactuService {
    constructor(private http: HttpClient) { }

    getAuthorization(): Observable<PaginableResponseModel<AdminVerifactuAuthorizationModel>> {
        return this.http.post<PaginableResponseModel<AdminVerifactuAuthorizationModel>>(
            `${environment.apiUrl}/api/v2/admin/verifactu-authorizations`,
            {}
        );
    }

    validateAuthorization(payload: { uid: string }): Observable<BaseResponseModel> {
        return this.http.post<BaseResponseModel>(
            `${environment.apiUrl}/api/v2/admin/verifactu-authorizations/validate`,
            payload
        );
    }

    revokeAuthorization(payload: { uid: string }): Observable<BaseResponseModel> {
        return this.http.post<BaseResponseModel>(
            `${environment.apiUrl}/api/v2/admin/verifactu-authorizations/revoke`,
            payload
        );
    }

    getDocumentAuthorization(payload: { uid: string }): Observable<SingleResponseModel<FileModel>> {
        return this.http.post<SingleResponseModel<FileModel>>(
            `${environment.apiUrl}/api/v2/users/verifactu-authorizations/document`,
            payload
        );
    }
}
